export default __webpack_public_path__ + "static/media/massachusetts.6810af33.jpg";